interface DenormalizeZipCode {
  value: string;
  digits?: number;
}

export function denormalizeZipCode({ value, digits }: DenormalizeZipCode) {
  return value.replace(/[-\s]/g, '').slice(0, digits ?? 9);
}
